import React from "react";
import ToggleButton from "react-bootstrap/ToggleButton";
import ToggleButtonGroup from "react-bootstrap/ToggleButtonGroup";

const SwToggleButtonGroup = ({
  type = "radio",          // radio | checkbox
  name,
  value,
  onChange,

  options = [],           // [{ label, value, disabled }]
  size = "md",            // md | sm | xs
  vertical = false,

  block = false,          // ✅ NEW: true | false

  className = "",
  ...rest
}) => {
  return (
    <ToggleButtonGroup
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      vertical={vertical}
      className={`
        SwToggleButton_GroupContainer 
        sw-toggle-group-${size}
        ${block ? "sw-toggle-btn-block" : ""}
        ${className}
      `}
      {...rest}
    >
      {options.map((opt, index) => (
        <ToggleButton
          key={index}
          id={`${name || "sw-tbg"}-${opt.value}`}
          type={type}
          value={opt.value}
          disabled={opt.disabled}
          className={`sw-toggle-btn sw-toggle-btn-${size}`}
        >
          {opt.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default SwToggleButtonGroup;
